module.exports = __webpack_public_path__ + "media/images/flags/64/Luxembourg-cde7fba4e9747e6819e42ff262ea9c93.png";